const variantsPerDisplay = "multi";
const wishlist = "local" as "local" | "centra";
const animationDurationContent = 0.8;
const animationDurationModal = 0.5;
const animationDelay = 0.2;
const YarnToRecipeRatio = 4;

const tags = {
  outlet: "Outlet",
  sale: "Outlet",
  new: "Nyhet",
  comingSoon: "Kommer snart",
  free: "Gratis",
};

const config = {
  variantsPerDisplay,
  wishlist,
  animationDurationContent,
  animationDurationModal,
  animationDelay,
  YarnToRecipeRatio,
  tags,
};

export default config;

export const MARKET = "5";
export const PRICELIST = "23";
export const CENTRA_PARAMS = {
  pricelist: "all",
  market: MARKET,
};
